import { forwardRef, useImperativeHandle, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import { toPng } from "html-to-image";
import ScatterChart from "../components/chart/ScatterChart";
import { M3Surface } from "../components/m3";
import { computePciData } from "./computePciData";
import { GWP_LOG_AXIS } from "./gwpScatterAxes";

// Chart cards fill their grid cell; the chart draws its own title bar.
const CHART_SURFACE_STYLE = { height: "100%", overflow: "hidden" };

const NomarlizedGwpVsPercentagePciChart = forwardRef(({ topic = "Product", combined_data, productId }, parentRef) => {
  const { t } = useTranslation();
  const ref = useRef();

  useImperativeHandle(parentRef, () => ({
    getScreenshot: async () => {
      if (ref.current) {
        return await toPng(ref.current, { cacheBust: true, backgroundColor: "#ffffff" });
      }
      return null;
    },
  }));

  const { rows, percentageOverallPci } = useMemo(() => {
    return computePciData(combined_data, topic, productId);
  }, [combined_data, topic, productId]);

  const x = useMemo(() => ({ type: "number", dataKey: "percentage_pci", name: "Percent PCI", unit: "" }), []);

  const referenceLines = useMemo(
    () => [{
      axis: "x",
      value: percentageOverallPci,
      label: `${t(topic + " PCI")} = ${percentageOverallPci.toFixed(1)}%`,
      dashed: true
    }],
    [percentageOverallPci, topic, t]
  );

  return (
    <M3Surface ref={ref} style={CHART_SURFACE_STYLE}>
      <ScatterChart
        x={x}
        y={GWP_LOG_AXIS}
        sizeKey={GWP_LOG_AXIS.dataKey}
        title={"GWP vs PCI Chart"}
        data={rows}
        referenceLines={referenceLines}
      />
    </M3Surface>
  );
});

export default NomarlizedGwpVsPercentagePciChart;
